<div *ngIf="message"
     style="background-color: #d40511; color: white; display:inline-block; width:100% ;text-align:left;" class="px-2 py-3 mb-2">
     <div class="d-flex">

     <div class="">
  <i class="bi bi-exclamation-circle me-2" style="font-size:xx-large; padding:10px"></i></div>
     <div class="">
  <span>{{message}}</span></div>

     </div>
</div>
